import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { catchError, mapTo, tap, map } from 'rxjs/operators';
// import * as moment from 'moment';
// import * as moment_tz from 'node_modules/moment-timezone';

import axios from "axios";


@Injectable({ providedIn: 'root' })
export class UserService {
    private defaultUrl: any;
    constructor(private http: HttpClient) {

        this.defaultUrl = axios.create({
            baseURL: environment.API
        });
    }

    public getUserdata(status): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_USER_DATA}?status=${status}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getFarmselect(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_FARM_SELECT}?orgId=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public createUser(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_CREATE_USER}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getUserByUsername(): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_USER_BY_USERNAME}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public updateFarmAuthorize(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_FARM_AUTHORIZE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getUserByid(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_USER_BY_ID}?userId=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public updateUser(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_USER}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public checkRole(): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_CHECK_ROLE}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public deleteUser(id): Observable<any> {
        return this.http.delete<any>(`${environment.API}${environment.URL_DELETE_USER}/${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
}
